<template>
  <section id="main-container" style="background-color: rgb(230, 230, 230);">
    <v-container fluid>
      <v-layout flex>
        <v-flex xs12 style="max-width:1020px;margin:0 auto;">
          <div id="centered-content">
            <img
              height="160px"
              style="margin:0 auto; display:block; padding-bottom:40px; "
              slot="activator"
              src="../assets/login-cb-logo.svg"
            />
            <!--<v-card class="pa-4">
              <v-card-text class="login-box-text ma-0 pa-0">
                <h1 class="primary--text">Login</h1>
               <v-flex ma-0 mb-3 mt-0>
                <v-alert
                    id="submit-feedback"
                    :value="showValidationMessage"
                  >{{ validationMessage }}</v-alert>
                </v-flex>

                <v-form ref="form" @keyup.native.enter="submit">
                  <v-text-field
                    box
                    label="Email Address"
                    v-model="username"
                    required
                    type="email"
                    class="mb-2"
                  ></v-text-field>
                  <v-text-field
                    box
                    label="Password"
                    v-model="password"
                    :append-icon="showPass ? 'visibility_off' : 'visibility'"
                    :type="showPass ? 'text' : 'password'"
                    @click:append="showPass = !showPass"
                    min="6"
                    required
                    class="mb-1"
                  ></v-text-field>
                  <v-flex xs12>
                    <v-btn right class="ma-0" flat id="forgot-password-container">
                      <router-link
                        class="no-link-style"
                        :to="{ name: 'ForgotPassword'}"
                        id="forgot-password"
                      >Forgot Password?</router-link>
                    </v-btn>
                  </v-flex>

                  <v-btn class="ml-0 mt-2" color="success"  @click="loader = 'loading'" id="login-button" :loading="loading"
      :disabled="loading">Login</v-btn>
                </v-form>
              </v-card-text>
            </v-card>-->
            <v-layout wrap row>
              <v-flex
                xs12
                md6
                class="login-box pa-4"
                style="border-top-right-radius: 5px;border-bottom-right-radius: 0px; border-bottom-left-radius: 0px;border-top-left-radius: 5px;'"
                :style="$vuetify.breakpoint.mdAndUp && 'border-top-right-radius: 0px;border-bottom-right-radius: 0px; border-bottom-left-radius: 5px;border-top-left-radius: 5px;'"
              >
                <!-- if no promo box simply add class 'no-promo' to the above v-flex. -->
                <v-flex style="display:table; height:100%; width:100%;" class="pa-4">
                  <div style="display:table-cell; vertical-align:middle;">
                    <v-layout v-if="logoUrl" class="brand-logo mb-4 px-4 mx-4">
                      <img class="" :src="logoUrl"/> <!-- Image width is 318px.-->
                    </v-layout>
                    <!--<h1 class="primary--text pb-3">Login</h1>-->
                    <v-form ref="form" @keyup.native.enter="submit">
                      <template v-if="!disablePasswordLogin">
                      <v-text-field
                        box
                        label="Email Address"
                        v-model="username"
                        required
                        type="email"
                        autocomplete="email"
                        class="mb-2"
                        :rules="emailRules"
                      ></v-text-field>
                      <v-text-field
                        box
                        label="Password"
                        v-model="password"
                        :append-icon="showPass ? 'visibility_off' : 'visibility'"
                        :type="showPass ? 'text' : 'password'"
                        autocomplete="current-password"
                        @click:append="showPass = !showPass"
                        min="6"
                        required
                        class="mb-0"
                      ></v-text-field>

                      <!--<v-btn class="ml-0 mb-4 mt-0" color="tertiary" block @click="submit" aria-label="Login">Login</v-btn> Commented out to show loging button loading state -->
                      <v-btn class="ml-0 mb-4 mt-0" color="tertiary" block @click="submit" :loading="loading" aria-label="Login">Login</v-btn>
                      </template>
                      <p v-if="ssoEnabled && !disablePasswordLogin" class="sso-divider caption grey--text text-xs-center mb-3">or</p>
                      <v-btn
                        v-if="ssoEnabled"
                        id="sso-login-button"
                        class="ml-0 mb-4 mt-0"
                        color="primary"
                        outline
                        block
                        :loading="ssoStarting"
                        @click="startSso"
                      >{{ ssoButtonLabel }}</v-btn>
                      <v-alert
                        id="submit-feedback"
                        :value="showValidationMessage"
                        :type="flashSeverity"
                        class="mb-3"
                        style="margin-top:-10px;"
                      >{{ validationMessage }}</v-alert>
                      <router-link v-if="!disablePasswordLogin" :to="{ name: 'ForgotPassword' }" id="forgot-password">
                      <v-btn
                        style="height:19px;text-transform:none;"
                        :ripple="false"
                        class="ma-0 pa-0 text-link-button d-block"
                        flat
                      >Forgotten your password?</v-btn>
                      </router-link>
                      <!-- <router-link :to="{ name: 'CustomDomain' }" id="custom-domain">
                      <v-btn
                        :ripple="false"
                        class="ma-0 pa-0 text-link-button"
                        flat
                        style="height:19px;text-transform:none;"
                      >Use my custom domain</v-btn>
                      </router-link><br/>
                      <a style="height:19px;text-transform:none;" class="ma-0 pa-0 text-link-button" href="/v2/auth/login-office-365" id="office-365">Login using Office 365</a> -->
                    </v-form>
                  </div>
                </v-flex>
              </v-flex>
              <v-flex
                xs12
                md6
                class="promo-box pa-4"
                style="border-top-right-radius: 0px;border-bottom-right-radius: 5px; border-bottom-left-radius: 5px;border-top-left-radius: 0px;'"
                :style="$vuetify.breakpoint.mdAndUp && 'border-top-right-radius: 5px;border-bottom-right-radius: 5px; border-bottom-left-radius: 0px;border-top-left-radius: 0px;'"
              >
                <v-flex style="display:table; height:100%;width:100%;" class="pa-4">
                  <div style="display:table-cell; vertical-align:middle;">
                    <h2 class="pb-2" style="line-height:1.2em;">
                      Explore the latest new
                      features in Caseblocks
                    </h2>
                    <p>
                      We’ve been busy developing and expanding Caseblocks
                      core functionalilty to make it even better.
                    </p>
                    <a href="https://caseblocks.com" class="no-link-style">
                      <v-btn class="ml-0 mt-1" color="secondary" outline>Explore</v-btn>
                    </a>
                  </div>
                </v-flex>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>
<script>
// Note: Requests to c.1password.com/richicons/images/login/120/<domain>.png are from the
// 1Password browser extension, not from this app. The extension fetches site icons for the
// login form and for each of the user's saved logins that match the site (so multiple
// accounts → multiple requests). Users can disable in 1Password: Settings > Appearance >
// turn off "Show app and website icons".
import { mapState } from "vuex"
import { getSsoConfig } from "@/provider/authentication.js"
import cfg from "@/cfg.js"

export default {
  name: "login", // eslint-disable-line vue/multi-word-component-names
  components: {},
  data: () => {
    return {
      // loader: null,
      // loading: false,
      password: "",
      username: "",
      showPass: false,
      logoUrl: "", // To be replaced with url to uploaded account logo
      ssoEnabled: false,
      ssoButtonLabel: "Sign in with SSO",
      disablePasswordLogin: false,
      ssoStarting: false,
      emailRules: [
        v => !!v || "E-mail is required",
        v =>
          /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,63})+$/.test(v) ||
          "E-mail must be valid"
      ]
    }
  },
  mounted() {
    if (this.$route && this.$route.query && this.$route.query.sso_error) {
      this.$store.commit("displayFlashMessage", {
        message: this.$route.query.sso_error,
        severity: "error"
      })
    }
    this.loadSsoConfig()
  },
  methods: {
    async loadSsoConfig() {
      const config = await getSsoConfig()
      this.ssoEnabled = !!(config && config.enabled)
      this.ssoButtonLabel = (config && config.buttonLabel) || "Sign in with SSO"
      this.disablePasswordLogin = !!(config && config.disablePasswordLogin)
    },
    startSso() {
      this.ssoStarting = true
      const origin = window.location.origin
      const api = String(cfg.apiEndPoint() || "").replace(/\/+$/, "")
      let url = api + "/sso/oidc/start?return_origin=" + encodeURIComponent(origin)
      if (this.$route && this.$route.query && this.$route.query.next) {
        url = url + "&next=" + encodeURIComponent(String(this.$route.query.next))
      }
      window.location.href = url
    },
    submit() {
      // this.loader = 'loading'
      let next
      if (this.$route && this.$route.query) {
        next = this.$route.query.next
      }
      this.$store.dispatch("requestLogin", {
        username: this.username,
        password: this.password,
        next,
      })
    }
  },
  computed: {
    showValidationMessage() {
      return !!this.validationMessage
    },
    validationMessage() {
      return this.flashMessage ? this.flashMessage.message : undefined
    },
    flashSeverity() {
      if (this.flashMessage && this.flashMessage.severity === "success") {
        return "success"
      }
      if (this.flashMessage && this.flashMessage.severity === "warning") {
        return "warning"
      }
      return "error"
    },
    ...mapState({
      flashMessage: state => state.ui.flashMessage,
      loading: state => state.ui.loading
    })
  }
}
</script>
<style>
#main-container {
  min-height: 100vh;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}

#centered-content {
  -webkit-box-shadow: none;
  box-shadow: none;
  padding: 0;
}

#centered-content h1 {
  font-size: 2.9em;
}

.login-box {
  background: white;
}

.login-box.no-promo {
  margin: 0 auto;
  border-radius: 5px !important;
}

.promo-box {
  background: #fbb6b6;
}

.brand-logo img {
   max-width:100%;
 max-height:100%;
}

.sso-divider {
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
</style>
